import React, { useEffect } from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom'; // ← Agregar Link
import { getMyNotifications } from '../../api/Api';
import Header from '../../components/Header';
import { useLoadingContext } from '../../contexts/LoadingContext';

const MyNotificationsPage = () => {
  const [notifications, setNotifications] = useState([]);
  const { setLoading } = useLoadingContext();

  useEffect(() => {
    const fetchNotifications = async () => {
      setLoading(true);
      const body = await getMyNotifications();
      filterNotifications(body);
      setLoading(false);
    };
    fetchNotifications();
  }, [setLoading])

  const filterNotifications = (notifications) => {
    setNotifications(notifications);
  }

  const Notification = ({ notification }) => {
    return (
      <article className="media">
        <figure className="media-left">
          <p className="image is-64x64">
            <img src="/assets/images/file128.png" alt="logo" />
          </p>
        </figure>
        <div className="media-content">
          <div className="content">
            <p>
              {/* CAMBIO: a → Link */}
              <Link to={`/portal/orden/${notification.order.order_number}`}>
                Orden {notification.order.order_number}
              </Link>
              <br />
              Esta orden fue creada/modificada recientemente, o contiene materiales adjuntos que no descargaste
            </p>
          </div>
        </div>
      </article>
    )
  }

  return (
    <div className="section">
      <Header />
      <div className="section">
        {notifications.map((notification, index) => 
          <Notification key={index} notification={notification} />
        )}
        {notifications.length === 0 &&
          <h3 className='title'>No tienes notificaciones</h3>
        }
      </div>
    </div>
  )
}

export default MyNotificationsPage;